// src/pages/FacebookTokenHelper.jsx
import React from 'react';

const FacebookTokenHelper = () => {
  const clientId = process.env.REACT_APP_FB_PUBLIC;
  const clientSecret = process.env.REACT_APP_FB_SECRET;
  const redirectUri = "https://app.manager.le-celadon.ma/"; // Doit être défini dans Facebook Dev Console
  const scopes = [
    "catalog_management",
    "pages_show_list",
    "ads_management",
    "ads_read",
    "business_management",
    "instagram_basic",
    "instagram_content_publish",
    "pages_read_engagement",
    "pages_manage_metadata",
    "pages_manage_posts",
    "instagram_shopping_tag_products",
    "public_profile"
  ];

  // Étape 1 : Récupère App Access Token (client_credentials)
  const getFacebookAppAccessToken = async () => {
    try {
      const res = await fetch(
        `https://graph.facebook.com/oauth/access_token?client_id=${clientId}&client_secret=${clientSecret}&grant_type=client_credentials`
      );
      const data = await res.json();
      if (data.access_token) {
        sessionStorage.setItem('fb_access_token', data.access_token);
        console.log("✅ App Access Token enregistré :", data.access_token);
      } else {
        console.error("❌ Erreur récupération App Token :", data);
      }
    } catch (err) {
      console.error("❌ Erreur réseau App Token :", err);
    }
  };

  // Étape 2 : Lance popup pour authentifier l'utilisateur et obtenir un code
  const getFacebookUserAuthCode = () => {
    const authUrl = `https://www.facebook.com/v22.0/dialog/oauth?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${scopes.join(",")}&response_type=code`;

    const popup = window.open(authUrl, "fbLogin", "width=800,height=600");

    const interval = setInterval(() => {
      try {
        if (popup.location.href.includes("code=")) {
          const urlParams = new URLSearchParams(popup.location.search);
          const authCode = urlParams.get("code");
          popup.close();
          clearInterval(interval);
          exchangeCodeForUserToken(authCode);
        }
      } catch (err) {
        // Popup redirect est cross-origin jusqu'à ce qu'elle revienne à notre domaine
      }
    }, 1000);
  };

  // Étape 3 : Échange le code contre un User Access Token
  const exchangeCodeForUserToken = async (code) => {
    try {
      const res = await fetch(
        `https://graph.facebook.com/v20.0/oauth/access_token?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&client_secret=${clientSecret}&code=${code}`
      );
      const data = await res.json();
      if (data.access_token) {
        sessionStorage.setItem('fb_user_token', data.access_token);
        console.log("✅ User Access Token enregistré :", data.access_token);
      } else {
        console.error("❌ Erreur échange code :", data);
      }
    } catch (err) {
      console.error("❌ Erreur réseau User Token :", err);
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold mb-4">🔐 Authentification Facebook</h2>
      <button
        className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded mr-4"
        onClick={getFacebookAppAccessToken}
      >
        Obtenir App Access Token
      </button>
      <button
        className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
        onClick={getFacebookUserAuthCode}
      >
        Connexion Utilisateur Facebook
      </button>
    </div>
  );
};

export default FacebookTokenHelper;
